'use strict';

import App from 'system/app'
import {ThemeMainNav,ThemeFooter} from './theme'
Vue.component('theme-main-nav',ThemeMainNav)
Vue.component('theme-footer',ThemeFooter)

// routed modules
import '@expressive-analytics/vue-login'

// styles
import "css"

// make sure that all routed modules are loaded before calling init()
// i.e. if your route contains "use:", load it above
App.init()

import Vue from 'vue'
Vue.config.productionTip = false // stop being annoying

import buttonGrid from 'components/test/tripleDial.vue'
Vue.component("survey-button-grid",buttonGrid)

import VueSelect from 'vue-select'
Vue.component('v-select',VueSelect)
import "vue-select/dist/vue-select.css"

import dayjs from "dayjs";
Vue.filter("date", (val, fmt) => {
  return dayjs(val).format(fmt);
});
